<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Cryptographic Key Required</h2>
    <button 
      mat-icon-button 
      class="close-button" 
      (click)="onCancel()"
      [disabled]="isLoading"
      aria-label="Close dialog">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="dialog-content">
    <div class="icon-container">
      <i class="fa fa-key key-icon"></i>
    </div>

    <div class="message-container">
      <p class="workspace-info">
        Workspace key not found. Please create a key to enable Data access.
        <strong>"{{ data.workspaceName }}"</strong>
      </p>

      <p class="description">
        A key pair is required to sign and authenticate your API requests securely.
      </p>

      <div class="info-box">
        <div class="info-title">
          <i class="fa fa-info-circle"></i>
          What happens when you create a key:
        </div>
        <ul class="info-list">
          <li>
            <i class="fa fa-check-circle"></i>
            A secure key pair will be generated in your browser
          </li>
          <li>
            <i class="fa fa-check-circle"></i>
            The private key will be stored securely in your browser's IndexedDB
          </li>
          <!-- <li>
            <i class="fa fa-check-circle"></i>
            A backup copy will be downloaded to your device
          </li> -->
          <li>
            <i class="fa fa-check-circle"></i>
            Only the public key will be sent to the server
          </li>
        </ul>
      </div>

      <!-- <div class="warning-box">
        <i class="fa fa-exclamation-triangle"></i>
        <span>Keep your downloaded private key safe. You'll need it to access this workspace from other devices.</span>
      </div> -->
    </div>
  </div>

  <div class="dialog-actions">
    <button 
      class="btn-cancel" 
      (click)="onCancel()"
      [disabled]="isLoading">
      Cancel
    </button>
    <button 
      class="btn-create" 
      (click)="onCreate()"
      [disabled]="isLoading">
      <!-- ✅ Changed to @if syntax -->
      @if (!isLoading) {
        <span>
          <i class="fa fa-key"></i>
          Generate Key Pair
        </span>
      }
      @if (isLoading) {
        <span>
          <i class="fa fa-spinner fa-spin"></i>
          Creating...
        </span>
      }
    </button>
  </div>
</div>